import React, { useState } from "react";
import { FormGroup, Label, Input, Button, Row, Col, Form } from "reactstrap";
import Swal from "sweetalert2";
import { useHistory, useParams } from "react-router-dom";
import api from "../../Axios"; // adjust based on your structure

const AddFamily = () => {
  const history = useHistory();
  const { id } = useParams();

  const [data, setData] = useState({
    fatherStatus: "",
    motherStatus: "",
    elderBrothers: "",
    elderBrothersMarried: "",
    youngerBrothers: "",
    youngerBrothersMarried: "",
    elderSisters: "",
    elderSistersMarried: "",
    youngerSisters: "",
    youngerSistersMarried: "",
    familyType: "",
    familyStatus: "",
    member1: "",
    member1Mobile: "",
    member2: "",
    member2Mobile: "",
  });

  const statusList = [
    "Private Employed",
    "Government Employed",
    "Business Man",
    "Self Employed",
    "Daily Wages",
    "Retired",
    "Not Employed",
    "Passed Away",
  ];

  const status = [
    "Private Employed",
    "Government Employed",
    "Business Man",
    "Self Employed",
    "Daily Wages",
    "Retired",
    "Homemaker",
    "Passed Away",
  ];
  const numberList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, "None"];
  const familyTypes = ["Joint  Family", "Nuclear Family"];
  const familyStatuses = ["Middle Class", "Upper Middle Class", "Well settled", "Lower Middle Class"];
  const member1 = ["Father", "Mother", "Sibling", "Other"]


  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "member1Mobile" || name === "member2Mobile") {
      const cleanedValue = value.replace(/\D/g, "").slice(0, 10);
      setData({
        ...data,
        [name]: cleanedValue,
      });
    } else {
      setData({
        ...data,
        [name]: value,
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      userId: parseInt(id),
      ...data,
    };

    api
      .post("/admin/userProfile/userFamily/", payload)
      .then((res) => {
        Swal.fire("Success", "Family details saved successfully", "success");
        history.push(`/addaddress/${id}`);
      })
      .catch((err) => {
        Swal.fire(
          "Error",
          (err && err.message) || "Something went wrong",
          "error"
        );
      });
  };

  const getMarriedOptionsFor = (countValue) => {
    if (countValue === "None" || countValue === "") return ["None"];

    const count = parseInt(countValue);
    const options = [];

    for (let i = 1; i <= count; i++) {
      options.push(i);
    }

    options.push("None");

    return options;
  };


  const styles = {
    label: {
      fontWeight: "800",
      color: "#000",
      marginBottom: 6,
    },
    input: {
      border: "1.5px solid #757575",
      borderRadius: 12,
      padding: 10,
      fontWeight: "bold",
      fontSize: 15,
      color: "#333",
    },
    heading: {
      color: "#000",
      fontWeight: "900",
      padding: "20px 10px 0px 10px",
      marginTop: "50px",
    },
    button: {
      width: "30%",
      borderRadius: 8,
      backgroundColor: "#000",
      color: "#fff",
      fontWeight: "bold",
      padding: "10px 0",
    },
  };

  return (
    <>
      <div style={styles.heading}>
        <h4>Family Details</h4>
      </div>
      <Form
        style={{ padding: 24, maxWidth: 1200, margin: "0 10" }}
        onSubmit={handleSubmit}
      >
        {/* Father & Mother Status */}
        <FormGroup>
          <Label for="fatherStatus" style={styles.label}>
            Father’s Status
          </Label>
          <Input
            type="select"
            name="fatherStatus"
            value={data.fatherStatus}
            onChange={handleChange}
            required
            style={styles.input}
          >
            <option value="">Select</option>
            {statusList.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </Input>
        </FormGroup>

        <FormGroup>
          <Label for="motherStatus" style={styles.label}>
            Mother’s Status
          </Label>
          <Input
            type="select"
            name="motherStatus"
            value={data.motherStatus}
            onChange={handleChange}
            required
            style={styles.input}
          >
            <option value="">Select</option>
            {status.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </Input>
        </FormGroup>

        {/* Sibling Details */}
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label style={styles.label}>Elder Brothers</Label>
              <Input
                type="select"
                name="elderBrothers"
                value={data.elderBrothers}
                onChange={handleChange}
                required
                style={styles.input}
              >
                <option value="">Select</option>
                {numberList.map((n) => (
                  <option key={n} value={n}>
                    {n}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <Label style={styles.label}>Elder Brothers Married</Label>
              <Input
                type="select"
                name="elderBrothersMarried"
                value={data.elderBrothersMarried}
                onChange={handleChange}
                required
                style={styles.input}
              >
                <option value="">Select</option>
                {getMarriedOptionsFor(data.elderBrothers).map((n) => (
                  <option key={n} value={n}>
                    {n}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <FormGroup>
              <Label style={styles.label}>Younger Brothers</Label>
              <Input
                type="select"
                name="youngerBrothers"
                value={data.youngerBrothers}
                onChange={handleChange}
                required
                style={styles.input}
              >
                <option value="">Select</option>
                {numberList.map((n) => (
                  <option key={n} value={n}>
                    {n}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <Label style={styles.label}>Younger Brothers Married</Label>
              <Input
                type="select"
                name="youngerBrothersMarried"
                value={data.youngerBrothersMarried}
                onChange={handleChange}
                required
                style={styles.input}
              >
                <option value="">Select</option>
                {getMarriedOptionsFor(data.youngerBrothers).map((n) => (
                  <option key={n} value={n}>
                    {n}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <FormGroup>
              <Label style={styles.label}>Elder Sisters</Label>
              <Input
                type="select"
                name="elderSisters"
                value={data.elderSisters}
                onChange={handleChange}
                required
                style={styles.input}
              >
                <option value="">Select</option>
                {numberList.map((n) => (
                  <option key={n} value={n}>
                    {n}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <Label style={styles.label}>Elder Sisters Married</Label>
              <Input
                type="select"
                name="elderSistersMarried"
                value={data.elderSistersMarried}
                onChange={handleChange}
                required
                style={styles.input}
              >
                <option value="">Select</option>
                {getMarriedOptionsFor(data.elderSisters).map((n) => (
                  <option key={n} value={n}>
                    {n}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <FormGroup>
              <Label style={styles.label}>Younger Sisters</Label>
              <Input
                type="select"
                name="youngerSisters"
                value={data.youngerSisters}
                onChange={handleChange}
                required
                style={styles.input}
              >
                <option value="">Select</option>
                {numberList.map((n) => (
                  <option key={n} value={n}>
                    {n}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <Label style={styles.label}>Younger Sisters Married</Label>
              <Input
                type="select"
                name="youngerSistersMarried"
                value={data.youngerSistersMarried}
                onChange={handleChange}
                required
                style={styles.input}
              >
                <option value="">Select</option>
                {getMarriedOptionsFor(data.youngerSisters).map((n) => (
                  <option key={n} value={n}>
                    {n}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
        </Row>


        {/* Family Type and Status */}
        <FormGroup>
          <Label style={styles.label}>Family Type</Label>
          <Input
            type="select"
            name="familyType"
            value={data.familyType}
            onChange={handleChange}
            required
            style={styles.input}
          >
            <option value="">Select</option>
            {familyTypes.map((type) => (
              <option
                key={type}
                value={type}
                style={{ textTransform: "capitalize" }}
              >
                {type}
              </option>
            ))}
          </Input>
        </FormGroup>

        <FormGroup>
          <Label style={styles.label}>Family Status</Label>
          <Input
            type="select"
            name="familyStatus"
            value={data.familyStatus}
            onChange={handleChange}
            required
            style={styles.input}
          >
            <option value="">Select</option>
            {familyStatuses.map((status) => (
              <option
                key={status}
                value={status}
                style={{ textTransform: "capitalize" }}
              >
                {status}
              </option>
            ))}
          </Input>
        </FormGroup>

        {/* Family Contacts */}
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label style={styles.label}>Member 1</Label>
              <Input
                type="select"
                name="member1"
                value={data.member1}
                onChange={handleChange}
                required
                style={styles.input}
              >
                <option value="">Select Member</option>
                {member1.map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label style={styles.label}>Member 1 Mobile</Label>
              <Input
                type="number"
                name="member1Mobile"
                value={data.member1Mobile}
                onChange={handleChange}
                placeholder="Enter Mobile Number"
                required
                maxLength={10}
                style={styles.input}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <FormGroup>
              <Label style={styles.label}>Member 2</Label>
              <Input
                type="select"
                name="member2"
                value={data.member2}
                onChange={handleChange}
                required
                style={styles.input}
              >
                <option value="">Select Member</option>
                {member1.map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label style={styles.label}>Member 2 Mobile</Label>
              <Input
                type="number"
                name="member2Mobile"
                value={data.member2Mobile}
                maxLength={10}
                onChange={handleChange}
                placeholder="Enter Mobile Number"
                required
                style={styles.input}
              />
            </FormGroup>
          </Col>
        </Row>

        <Button type="submit" style={styles.button}>
          Save & Continue
        </Button>
      </Form>
    </>
  );
};

export default AddFamily;
